import { render } from "./mentalHealthVideo.vue?vue&type=template&id=006ceccd&scoped=true"
import script from "./mentalHealthVideo.vue?vue&type=script&lang=js"
export * from "./mentalHealthVideo.vue?vue&type=script&lang=js"

import "./mentalHealthVideo.vue?vue&type=style&index=0&id=006ceccd&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006ceccd"]])

export default __exports__